export const profileHasRequiredData = profile => {
  if(profile[ 'first_name' ] && profile[ 'last_name' ] && profile[ 'city' ]
  && profile[ 'country' ] && profile[ 'email' ]) {
    return true;
  }

  return false;
};

export const profileHasValidatedPhoneNumber = profile => (
  profile.validated_phone_number ? true : false
);



// WEBPACK FOOTER //
// ./src/utils/validation.js